/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { FirmwareVersionsResponse } from '../models';
import { GenerateUploadTokenRequest } from '../models';
import { GenerateUploadTokenResponse } from '../models';
import { SetPublishedVersionRequest } from '../models';
import { SetPublishedVersionResponse } from '../models';
import { UploadFirmwareResponse } from '../models';
/**
 * OTAFirmwareManagementApi - axios parameter creator
 * @export
 */
export const OTAFirmwareManagementApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Retrieves the latest published firmware version for each software type (CM7, CM4, ESP). Returns null for software types with no published firmware.
     * @summary Get latest firmware versions for all software types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otaControllerCheckFirmwaresVersion: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/ota/check-version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a unique, single-use token that allows a developer to upload firmware. Token is sent via email with a link. Only administrators can generate tokens.
     * @summary [ADMIN] Generate firmware upload authorization token
     * @param {GenerateUploadTokenRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otaControllerGenerateUploadToken: async (
      body: GenerateUploadTokenRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling otaControllerGenerateUploadToken.'
        );
      }
      const localVarPath = `/ota/admin/generate-upload-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Change which version is the (active) firmware for a specific software type. This will unpublish the currently active version and publish the specified one. Useful for rollbacks or switching between versions. Only administrators can change versions.
     * @summary [ADMIN] Set firmware version for a software type
     * @param {SetPublishedVersionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otaControllerSetVersion: async (
      body: SetPublishedVersionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling otaControllerSetVersion.'
        );
      }
      const localVarPath = `/ota/admin/set-version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Streams the latest firmware for a specific software type. Supports HTTP Range requests for resumable downloads. ONLY FOR LOCAL TESTING - in production, use the download endpoint to get the SAS URL and download directly from Azure.
     * @summary Stream firmware with range request support
     * @param {number} software_type Software type identifier: 0&#x3D;CM7, 1&#x3D;CM4, 2&#x3D;ESP
     * @param {string} range HTTP Range header for partial content requests (e.g., bytes&#x3D;0-1023)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otaControllerStreamFirmware: async (
      software_type: number,
      range: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'software_type' is not null or undefined
      if (software_type === null || software_type === undefined) {
        throw new RequiredError(
          'software_type',
          'Required parameter software_type was null or undefined when calling otaControllerStreamFirmware.'
        );
      }
      // verify required parameter 'range' is not null or undefined
      if (range === null || range === undefined) {
        throw new RequiredError(
          'range',
          'Required parameter range was null or undefined when calling otaControllerStreamFirmware.'
        );
      }
      const localVarPath = `/ota/stream/{softwareType}`.replace(
        `{${'softwareType'}}`,
        encodeURIComponent(String(software_type))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (range !== undefined && range !== null) {
        localVarHeaderParameter['range'] = String(range);
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Uploads a new firmware file for a specific software type. The version is either extracted from the filename (semver format) or provided explicitly. If a higher version is uploaded, the previous version is automatically unpublished. Cannot upload lower versions than the current published version.
     * @summary Upload new firmware version
     * @param {Blob} file
     * @param {number} software_type
     * @param {string} version
     * @param {string} checksum
     * @param {string} file_metadata
     * @param {string} upload_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otaControllerUploadFirmwareForm: async (
      file: Blob,
      software_type: number,
      version: string,
      checksum: string,
      file_metadata: string,
      upload_token: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      // verify required parameter 'software_type' is not null or undefined
      if (software_type === null || software_type === undefined) {
        throw new RequiredError(
          'software_type',
          'Required parameter software_type was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      // verify required parameter 'checksum' is not null or undefined
      if (checksum === null || checksum === undefined) {
        throw new RequiredError(
          'checksum',
          'Required parameter checksum was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      // verify required parameter 'file_metadata' is not null or undefined
      if (file_metadata === null || file_metadata === undefined) {
        throw new RequiredError(
          'file_metadata',
          'Required parameter file_metadata was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      // verify required parameter 'upload_token' is not null or undefined
      if (upload_token === null || upload_token === undefined) {
        throw new RequiredError(
          'upload_token',
          'Required parameter upload_token was null or undefined when calling otaControllerUploadFirmwareForm.'
        );
      }
      const localVarPath = `/ota/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (software_type !== undefined) {
        localVarFormParams.append('softwareType', software_type as any);
      }

      if (version !== undefined) {
        localVarFormParams.append('version', version as any);
      }

      if (checksum !== undefined) {
        localVarFormParams.append('checksum', checksum as any);
      }

      if (file_metadata !== undefined) {
        localVarFormParams.append('fileMetadata', file_metadata as any);
      }

      if (upload_token !== undefined) {
        localVarFormParams.append('uploadToken', upload_token as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OTAFirmwareManagementApi - functional programming interface
 * @export
 */
export const OTAFirmwareManagementApiFp = function (
  configuration?: Configuration
) {
  return {
    /**
     * Retrieves the latest published firmware version for each software type (CM7, CM4, ESP). Returns null for software types with no published firmware.
     * @summary Get latest firmware versions for all software types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerCheckFirmwaresVersion(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<FirmwareVersionsResponse>>
    > {
      const localVarAxiosArgs =
        await OTAFirmwareManagementApiAxiosParamCreator(
          configuration
        ).otaControllerCheckFirmwaresVersion(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Generate a unique, single-use token that allows a developer to upload firmware. Token is sent via email with a link. Only administrators can generate tokens.
     * @summary [ADMIN] Generate firmware upload authorization token
     * @param {GenerateUploadTokenRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerGenerateUploadToken(
      body: GenerateUploadTokenRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<GenerateUploadTokenResponse>>
    > {
      const localVarAxiosArgs = await OTAFirmwareManagementApiAxiosParamCreator(
        configuration
      ).otaControllerGenerateUploadToken(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Change which version is the (active) firmware for a specific software type. This will unpublish the currently active version and publish the specified one. Useful for rollbacks or switching between versions. Only administrators can change versions.
     * @summary [ADMIN] Set firmware version for a software type
     * @param {SetPublishedVersionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerSetVersion(
      body: SetPublishedVersionRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SetPublishedVersionResponse>>
    > {
      const localVarAxiosArgs = await OTAFirmwareManagementApiAxiosParamCreator(
        configuration
      ).otaControllerSetVersion(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Streams the latest firmware for a specific software type. Supports HTTP Range requests for resumable downloads. ONLY FOR LOCAL TESTING - in production, use the download endpoint to get the SAS URL and download directly from Azure.
     * @summary Stream firmware with range request support
     * @param {number} software_type Software type identifier: 0&#x3D;CM7, 1&#x3D;CM4, 2&#x3D;ESP
     * @param {string} range HTTP Range header for partial content requests (e.g., bytes&#x3D;0-1023)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerStreamFirmware(
      software_type: number,
      range: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Blob>>
    > {
      const localVarAxiosArgs = await OTAFirmwareManagementApiAxiosParamCreator(
        configuration
      ).otaControllerStreamFirmware(software_type, range, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Uploads a new firmware file for a specific software type. The version is either extracted from the filename (semver format) or provided explicitly. If a higher version is uploaded, the previous version is automatically unpublished. Cannot upload lower versions than the current published version.
     * @summary Upload new firmware version
     * @param {Blob} file
     * @param {number} software_type
     * @param {string} version
     * @param {string} checksum
     * @param {string} file_metadata
     * @param {string} upload_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerUploadFirmwareForm(
      file: Blob,
      software_type: number,
      version: string,
      checksum: string,
      file_metadata: string,
      upload_token: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<UploadFirmwareResponse>>
    > {
      const localVarAxiosArgs = await OTAFirmwareManagementApiAxiosParamCreator(
        configuration
      ).otaControllerUploadFirmwareForm(
        file,
        software_type,
        version,
        checksum,
        file_metadata,
        upload_token,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * OTAFirmwareManagementApi - factory interface
 * @export
 */
export const OTAFirmwareManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Retrieves the latest published firmware version for each software type (CM7, CM4, ESP). Returns null for software types with no published firmware.
     * @summary Get latest firmware versions for all software types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerCheckFirmwaresVersion(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<FirmwareVersionsResponse>> {
      return OTAFirmwareManagementApiFp(configuration)
        .otaControllerCheckFirmwaresVersion(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a unique, single-use token that allows a developer to upload firmware. Token is sent via email with a link. Only administrators can generate tokens.
     * @summary [ADMIN] Generate firmware upload authorization token
     * @param {GenerateUploadTokenRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerGenerateUploadToken(
      body: GenerateUploadTokenRequest,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<GenerateUploadTokenResponse>> {
      return OTAFirmwareManagementApiFp(configuration)
        .otaControllerGenerateUploadToken(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Change which version is the (active) firmware for a specific software type. This will unpublish the currently active version and publish the specified one. Useful for rollbacks or switching between versions. Only administrators can change versions.
     * @summary [ADMIN] Set firmware version for a software type
     * @param {SetPublishedVersionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerSetVersion(
      body: SetPublishedVersionRequest,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SetPublishedVersionResponse>> {
      return OTAFirmwareManagementApiFp(configuration)
        .otaControllerSetVersion(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Streams the latest firmware for a specific software type. Supports HTTP Range requests for resumable downloads. ONLY FOR LOCAL TESTING - in production, use the download endpoint to get the SAS URL and download directly from Azure.
     * @summary Stream firmware with range request support
     * @param {number} software_type Software type identifier: 0&#x3D;CM7, 1&#x3D;CM4, 2&#x3D;ESP
     * @param {string} range HTTP Range header for partial content requests (e.g., bytes&#x3D;0-1023)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerStreamFirmware(
      software_type: number,
      range: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Blob>> {
      return OTAFirmwareManagementApiFp(configuration)
        .otaControllerStreamFirmware(software_type, range, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Uploads a new firmware file for a specific software type. The version is either extracted from the filename (semver format) or provided explicitly. If a higher version is uploaded, the previous version is automatically unpublished. Cannot upload lower versions than the current published version.
     * @summary Upload new firmware version
     * @param {Blob} file
     * @param {number} software_type
     * @param {string} version
     * @param {string} checksum
     * @param {string} file_metadata
     * @param {string} upload_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otaControllerUploadFirmwareForm(
      file: Blob,
      software_type: number,
      version: string,
      checksum: string,
      file_metadata: string,
      upload_token: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<UploadFirmwareResponse>> {
      return OTAFirmwareManagementApiFp(configuration)
        .otaControllerUploadFirmwareForm(
          file,
          software_type,
          version,
          checksum,
          file_metadata,
          upload_token,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * OTAFirmwareManagementApi - object-oriented interface
 * @export
 * @class OTAFirmwareManagementApi
 * @extends {BaseAPI}
 */
export class OTAFirmwareManagementApi extends BaseAPI {
  /**
   * Retrieves the latest published firmware version for each software type (CM7, CM4, ESP). Returns null for software types with no published firmware.
   * @summary Get latest firmware versions for all software types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTAFirmwareManagementApi
   */
  public async otaControllerCheckFirmwaresVersion(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<FirmwareVersionsResponse>> {
    return OTAFirmwareManagementApiFp(this.configuration)
      .otaControllerCheckFirmwaresVersion(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Generate a unique, single-use token that allows a developer to upload firmware. Token is sent via email with a link. Only administrators can generate tokens.
   * @summary [ADMIN] Generate firmware upload authorization token
   * @param {GenerateUploadTokenRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTAFirmwareManagementApi
   */
  public async otaControllerGenerateUploadToken(
    body: GenerateUploadTokenRequest,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<GenerateUploadTokenResponse>> {
    return OTAFirmwareManagementApiFp(this.configuration)
      .otaControllerGenerateUploadToken(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Change which version is the (active) firmware for a specific software type. This will unpublish the currently active version and publish the specified one. Useful for rollbacks or switching between versions. Only administrators can change versions.
   * @summary [ADMIN] Set firmware version for a software type
   * @param {SetPublishedVersionRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTAFirmwareManagementApi
   */
  public async otaControllerSetVersion(
    body: SetPublishedVersionRequest,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SetPublishedVersionResponse>> {
    return OTAFirmwareManagementApiFp(this.configuration)
      .otaControllerSetVersion(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Streams the latest firmware for a specific software type. Supports HTTP Range requests for resumable downloads. ONLY FOR LOCAL TESTING - in production, use the download endpoint to get the SAS URL and download directly from Azure.
   * @summary Stream firmware with range request support
   * @param {number} software_type Software type identifier: 0&#x3D;CM7, 1&#x3D;CM4, 2&#x3D;ESP
   * @param {string} range HTTP Range header for partial content requests (e.g., bytes&#x3D;0-1023)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTAFirmwareManagementApi
   */
  public async otaControllerStreamFirmware(
    software_type: number,
    range: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Blob>> {
    return OTAFirmwareManagementApiFp(this.configuration)
      .otaControllerStreamFirmware(software_type, range, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Uploads a new firmware file for a specific software type. The version is either extracted from the filename (semver format) or provided explicitly. If a higher version is uploaded, the previous version is automatically unpublished. Cannot upload lower versions than the current published version.
   * @summary Upload new firmware version
   * @param {Blob} file
   * @param {number} software_type
   * @param {string} version
   * @param {string} checksum
   * @param {string} file_metadata
   * @param {string} upload_token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTAFirmwareManagementApi
   */
  public async otaControllerUploadFirmwareForm(
    file: Blob,
    software_type: number,
    version: string,
    checksum: string,
    file_metadata: string,
    upload_token: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<UploadFirmwareResponse>> {
    return OTAFirmwareManagementApiFp(this.configuration)
      .otaControllerUploadFirmwareForm(
        file,
        software_type,
        version,
        checksum,
        file_metadata,
        upload_token,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
